
export const isSandboxMode = process.env.STRIPE_MODE === "SANDBOX";
const environment = process.env.environment;

/* -------------------------------------------------------------------------- */
/*                              BRANDS PLANS                                  */
/* -------------------------------------------------------------------------- */
export const new_plans = [
  {
    id: 0,
    name: "Free",
    type: "monthly",
    currency: "€",
    seats: 999999999,
    amount: 0,
    credits: 0,
    max_credits: 20,
    product_id: "",
    crm_included: false,
    price_id: "",
  },
  // annual
  {
    id: 1,
    name: "Growth",
    type: "monthly",
    currency: "€",
    seats: 999999999,
    amount: 750,
    credits: 0,
    max_credits: 150,
    crm_included: true,
    product_id: isSandboxMode ? "prod_USd7dqamc282bF" : "prod_USdBVMY6EUaVXY",
    price_id: isSandboxMode
      ? "price_1TThqu1CzlXiZWkZ74lGtuL7"
      : !isSandboxMode && environment === "testing"
        ? "price_1TWt8p0wvFnd8vF849dHnPsd"
        : "price_1TThvC0wvFnd8vF8a71i2GDd",
  },
  {
    id: 2,
    name: "Growth",
    type: "annual",
    currency: "€",
    seats: 999999999,
    amount: 8100,
    credits: 0,
    max_credits: 150,
    crm_included: true,
    product_id: isSandboxMode ? "prod_USd9DpWtrCYgPY" : "prod_USdCG98Gczxj21",
    price_id: isSandboxMode
      ? "price_1TTht71CzlXiZWkZQUlUv8jd"
      : !isSandboxMode && environment === "testing"
        ? "price_1TWt6M0wvFnd8vF8IMP8cGqG"
        : "price_1TThw20wvFnd8vF8lTVY1T29",
  },
  // Seasonal Pass: 5 months; a copy of the backend's config/new-plans.ts entry
  {
    id: 3,
    name: "Seasonal Pass",
    type: "seasonal_pass",
    currency: "€",
    seats: 999999999,
    amount: 750,
    credits: 0,
    max_credits: 150,
    crm_included: true,
    product_id: isSandboxMode ? "prod_VReLjdRknHzXhV" : "prod_VEx2von5R70sk4",
    price_id: isSandboxMode
      ? "price_1UQl2z1CzlXiZWkZp6liCoZd"
      : !isSandboxMode && environment === "testing"
        ? ""
        : "price_1URViW0wvFnd8vF8leBNbcu5",
  },
];

export const credit_structure = {
  standard_match: 1,
  standard_proximity_match: 2,
  top_proximity_match: 3,
  missed_opportunities: 3,
  contact_reveal: 2,
};
